import moment from 'moment'
export default class PatientTableRowModel {
  constructor () {
    this.id = 0
    this.code = ''
    this.patientName = ''
    this.contactName = ''
    this.phone = ''
    this.area = ''
    this.status = ''
    this.statusText = ''
    this.statusBadge = ''
    this.createdAt = ''
    this.service = ''
  }

  static fromJSON (json) {
    let tableRow = new PatientTableRowModel()
    tableRow.id = json.id
    tableRow.code = json.id === 0 ? '-' : 'P' + json.id
    tableRow.patientName = json.patientName
    tableRow.contactName = json.contactName || json.patientName
    tableRow.phone = json.phone
    tableRow.area = json.area.replace('home, ', 'บ้าน, ').replace('hospital, ', 'โรงพยาบาล, ')
    tableRow.status = json.status
    tableRow.statusText = json.statusText
    tableRow.statusBadge = json.statusBadge
    tableRow.createdAt = moment(json.createdAt).format('DD/MM/YYYY, HH:mm')
    tableRow.service = {
      caregiver: 'ดูแลคนไข้',
      escort: 'พาไปหาหมอ'
    }[json.service]
    return tableRow
  }
}
